import { CardioOrResistance, ExerciseFormat } from '../entities/exercise/exercise';
import { WorkoutType } from './workouttype';

export class WarmupWarmdownConfig {
  public static WarmupWarmdownCardioMap: Map<number, Map<number, ExerciseFormat>> =
    new Map<number, Map<number, ExerciseFormat>>([
    [4, new Map([
      [1, ExerciseFormat.WarmupModerateBurn],
      [4, ExerciseFormat.WarmdownBurn],
    ])],
    [WorkoutType.FullStudioWorkout, new Map([
      [1, ExerciseFormat.WarmupLowBurn],
      [2, ExerciseFormat.WarmupModerateBurn],
      [23, ExerciseFormat.WarmdownBurn],
    ])],
    [WorkoutType.MediumStudioWorkout, new Map([
      [1, ExerciseFormat.WarmupModerateBurn],
      [14, ExerciseFormat.WarmdownBurn],
    ])],
    [WorkoutType.QuickStaticFunctionalWorkout, new Map([
      [1, ExerciseFormat.WarmupModerateBurn],
      [7, ExerciseFormat.WarmdownBurn],
    ])],
    [WorkoutType.QuickHomeOrStaticCardioWorkout, new Map([// home
      [1, ExerciseFormat.WarmupHybridBurn],
      [6, ExerciseFormat.WarmdownBurn],
    ])],
    [WorkoutType.MediumHomeOrStaticCardioWorkout, new Map([// home
      [1, ExerciseFormat.WarmupHybridBurn],
      [11, ExerciseFormat.WarmdownBurn],
    ])],
    [WorkoutType.FullHomeOrStaticCardioWorkout, new Map([// home
      [1, ExerciseFormat.WarmupHybridBurn],
      [16, ExerciseFormat.WarmdownBurn],
    ])],
    [WorkoutType.ExtraLongHomeOrStaticCardioWorkout, new Map([// home
      [1, ExerciseFormat.WarmupHybridBurn],
      [21, ExerciseFormat.WarmdownBurn],
    ])],
  ]);

  public static WarmupWarmdownResistanceMap: Map<number, Map<number, ExerciseFormat>> =
    new Map<number, Map<number, ExerciseFormat>>([
    [4, new Map([
      [1, ExerciseFormat.WarmupModerateBuild],
      [4, ExerciseFormat.WarmdownBuild],
    ])],
    [WorkoutType.FullStudioWorkout, new Map([
      [1, ExerciseFormat.WarmupLowBuild],
      [2, ExerciseFormat.WarmupModerateBuild],
      [23, ExerciseFormat.WarmdownBuild],
    ])],
    [WorkoutType.MediumStudioWorkout, new Map([
      [1, ExerciseFormat.WarmupModerateBuild],
      [14, ExerciseFormat.WarmdownBuild],
    ])],
    [WorkoutType.QuickStaticFunctionalWorkout, new Map([
      [1, ExerciseFormat.WarmupModerateBuild],
      [7, ExerciseFormat.WarmdownBuild],
    ])],
    [WorkoutType.QuickHomeOrStaticCardioWorkout, new Map([
      [1, ExerciseFormat.WarmupHybridBuild],
      [6, ExerciseFormat.WarmdownBuild],
    ])],
    [WorkoutType.MediumHomeOrStaticCardioWorkout, new Map([
      [1, ExerciseFormat.WarmupHybridBuild],
      [11, ExerciseFormat.WarmdownBuild],
    ])],
    [WorkoutType.FullHomeOrStaticCardioWorkout, new Map([
      [1, ExerciseFormat.WarmupHybridBuild],
      [16, ExerciseFormat.WarmdownBuild],
    ])],
    [WorkoutType.ExtraLongHomeOrStaticCardioWorkout, new Map([
      [1, ExerciseFormat.WarmupHybridBuild],
      [21, ExerciseFormat.WarmdownBuild],
    ])],
  ]);

  public static WarmupWarmdownBalanceMap: Map<number, Map<number, ExerciseFormat>> =
    new Map<number, Map<number, ExerciseFormat>>([
      [4, new Map([
        [1, ExerciseFormat.WUModBalance],
        [4, ExerciseFormat.WDBalanceStudio],
      ])],
      [WorkoutType.FullStudioWorkout, new Map([
        [1, ExerciseFormat.WULowBalance],
        [2, ExerciseFormat.WUModBalance],
        [23, ExerciseFormat.WDBalanceStudio],
      ])],
      [WorkoutType.MediumStudioWorkout, new Map([
        [1, ExerciseFormat.WUModBalance],
        [14, ExerciseFormat.WDBalanceStudio],
      ])],
      [WorkoutType.QuickStaticFunctionalWorkout, new Map([
        [1, ExerciseFormat.WUModBalance],
        [7, ExerciseFormat.WDBalanceStudio],
      ])],
    [WorkoutType.QuickHomeOrStaticCardioWorkout, new Map([ // home
      [1, ExerciseFormat.WUBalanceHybrid],
      [6, ExerciseFormat.WDBalance],
    ])],
    [WorkoutType.MediumHomeOrStaticCardioWorkout, new Map([ // home
      [1, ExerciseFormat.WUBalanceHybrid],
      [11, ExerciseFormat.WDBalance],
    ])],
    [WorkoutType.FullHomeOrStaticCardioWorkout, new Map([ // home
      [1, ExerciseFormat.WUBalanceHybrid],
      [16, ExerciseFormat.WDBalance],
    ])],
  ]);

  public static WarmupWarmdownStaticCardioMap: Map<number, Map<number, ExerciseFormat>> =
    new Map<number, Map<number, ExerciseFormat>>([
      [WorkoutType.QuickHomeOrStaticCardioWorkout, new Map([
        [1, ExerciseFormat.MachineSetupAndStretch],
        [6, ExerciseFormat.MachineEndAndStretch],
      ])],
      [WorkoutType.MediumHomeOrStaticCardioWorkout, new Map([
        [1, ExerciseFormat.MachineSetupAndStretch],
        [11, ExerciseFormat.MachineEndAndStretch],
      ])],
      [WorkoutType.FullHomeOrStaticCardioWorkout, new Map([
        [1, ExerciseFormat.MachineSetupAndStretch],
        [16, ExerciseFormat.MachineEndAndStretch],
      ])],
      [WorkoutType.ExtraLongHomeOrStaticCardioWorkout, new Map([
        [1, ExerciseFormat.MachineSetupAndStretch],
        [21, ExerciseFormat.MachineEndAndStretch],
      ])],
      [WorkoutType.FullStaticCardioWorkout, new Map([
        [1, ExerciseFormat.MachineSetupAndStretch],
        [26, ExerciseFormat.MachineEndAndStretch],
      ])],
  ]);

  public static tutorialWarmups: Map<number, { ref: string, instructor: string }> = new Map([
    [0, { ref: '21136', instructor: 'Dave' }],
    [1, { ref: '21132', instructor: 'Dave' }],
  ]);

  public static tutorialBalanceWarmups: Map<number, { ref: string, instructor: string }> = new Map([
    [0, { ref: '25242', instructor: 'Eliza' }],
    [1, { ref: '25243', instructor: 'Eliza' }],
  ]);

  public static getTutorialWarmup(workoutCount: number) {
    return this.tutorialWarmups.get(workoutCount);
  }

  public static getBalanceTutorialWarmup(workoutCount: number) {
    return this.tutorialBalanceWarmups.get(workoutCount);
  }

  public static isTutorialWarmupNeeded(workoutCount: number) {
    if (!WarmupWarmdownConfig.isTutorialWarmupsEnabled()) {
      return false;
    }
    return this.tutorialWarmups.size > workoutCount;
  }

  public static isTutorialWarmup(ref: string) {
    return Array.from([
      ...this.tutorialWarmups,
      ...this.tutorialBalanceWarmups]).some(([_, value]) => value.ref === ref);
  }

  public static isTutorialWarmupsEnabled() {
    return true;
  }

  public static getFormatFor(
    stages: number,
    cardioOrResistance?: CardioOrResistance,
    isCardioMachineZone?: boolean,
  )
  : Map<number, string> | undefined {
    if (isCardioMachineZone) {
      return WarmupWarmdownConfig.WarmupWarmdownStaticCardioMap.get(stages);
    }
    if (cardioOrResistance === CardioOrResistance.Resistance) {
      return WarmupWarmdownConfig.WarmupWarmdownResistanceMap.get(stages);
    }
    if (cardioOrResistance === CardioOrResistance.Balance) {
      return WarmupWarmdownConfig.WarmupWarmdownBalanceMap.get(stages);
    }
    return WarmupWarmdownConfig.WarmupWarmdownCardioMap.get(stages);
  }

  public static isWarmupOrWarmdown(exerciseFormat: ExerciseFormat) {
    return WarmupWarmdownConfig.allWarmupAndWarmdownFormats().indexOf(exerciseFormat) !== -1;
  }

  public static getSupportedWarmupWarmdownFormatsFromConfig(): ExerciseFormat[] {
    return WarmupWarmdownConfig.allWarmupAndWarmdownFormats();
  }

  public static getCorrectWarmdupdownFormatForSetting(
    originalFormat: ExerciseFormat,
    cardioOrResistanceSetting: CardioOrResistance,
  ): ExerciseFormat {
    return this.getCorrectWarmupFormatIfSettingsChange(
      originalFormat,
      cardioOrResistanceSetting,
    );
  }

  public static allWarmupFormats(): ExerciseFormat[] {
    return [ExerciseFormat.Warmup50Stretch, ExerciseFormat.Warmup50Pace, ExerciseFormat.Warmup30Hybrid,
      ExerciseFormat.WarmupLowBuild, ExerciseFormat.WarmupModerateBuild,
      ExerciseFormat.WarmupLowBurn, ExerciseFormat.WarmupModerateBurn,
      ExerciseFormat.WarmupHybridBurn, ExerciseFormat.WarmupHybridBuild,
      ExerciseFormat.WUBalanceHybrid, ExerciseFormat.WULowBalance,
      ExerciseFormat.WUModBalance,
    ];
  }

  public static allWarmdownFormats(): ExerciseFormat[] {
    return [ExerciseFormat.WarmdownBuild, ExerciseFormat.WarmdownBurn, ExerciseFormat.Warmdown30Hybrid,
      ExerciseFormat.WDBalance, ExerciseFormat.WDBalanceStudio];
  }

  public static allWarmupAndWarmdownFormats(): ExerciseFormat[] {
    return WarmupWarmdownConfig.allWarmupFormats().concat(WarmupWarmdownConfig.allWarmdownFormats());
  }

  private static getCorrectWarmupFormatIfSettingsChange(
    originalFormat: ExerciseFormat,
    cardioOrResistanceSetting: CardioOrResistance,
  ): ExerciseFormat {
    const positionKeysInOriginalWarmupFormatMap =
      WarmupWarmdownConfig.findKeysInWarmupMaps(originalFormat);

    if (!positionKeysInOriginalWarmupFormatMap) {
      return originalFormat;
    }
    const [amountOfStages, warmupStage] = positionKeysInOriginalWarmupFormatMap;
    const warmupFormatForWorkoutType = this.getFormatFor(
      amountOfStages,
      cardioOrResistanceSetting,
    );
    const warmupFormat = warmupFormatForWorkoutType?.get(warmupStage) as ExerciseFormat;
    return warmupFormat ?? originalFormat;
  }

  private static findKeysInWarmupMaps(
    targetValue: ExerciseFormat,
  ): [number, number] | null {
    const maps = [
      WarmupWarmdownConfig.WarmupWarmdownCardioMap,
      WarmupWarmdownConfig.WarmupWarmdownResistanceMap,
      WarmupWarmdownConfig.WarmupWarmdownBalanceMap,
    ];
    for (const mainMap of maps) {
      for (const [outerKey, innerMap] of mainMap) {
        for (const [innerKey, value] of innerMap) {
          if (value === targetValue) {
            return [outerKey, innerKey];
          }
        }
      }
    }
    return null;
  }
}
